import { IValidationResult, validResult } from '../ValidateEntry';
import { Is1TimeGoal } from './Is1TimeGoal';

export const Validate1TimeGoalValue = (entryText: string): IValidationResult => {
	const goalValue: number = parseInt(entryText.split(' ')[3]);
		
	if (Is1TimeGoal(entryText, true) && goalValue > 1) {
		throw new Error('A 1-time goal must have a goal value of 1 or less');
	}
	
    return validResult;
};

